import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthValidationError, LoginFailure, LoginRequest, LoginSuccess } from '../../../store/auth/auth.actions';
import { Actions, ofType } from '@ngrx/effects';
import { take } from 'rxjs/internal/operators/take';
import { ValidationErrorComponent } from '../../../components/core/validation-error/validation-error.component';
import { BRANDING } from '../../../core/config/branding';

@Component({
  selector: 'app-login',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    RouterLink,
    ValidationErrorComponent
  ],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login {
  protected readonly brand = BRANDING;
  private readonly formBuilder = inject(FormBuilder);
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);
  private readonly router = inject(Router);
  validationError = signal<string[]>([]);


  protected readonly hidePassword = signal(true);

  protected readonly loginForm = this.formBuilder.group({
    countryCode: ['+1', [Validators.required]],
    phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
    password: ['', [Validators.required, Validators.minLength(8)]],
  });

  protected togglePassword(): void {
    this.hidePassword.set(!this.hidePassword());
  }

  protected onLogin(): void {
    this.validationError.set([]);
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const formValue = this.loginForm.getRawValue();
    const phone = `${formValue.countryCode}${formValue.phone ?? ''}`;
    const password = formValue.password ?? '';
    this.store.dispatch(LoginRequest({ payload: { phone, password } }));

    this.actions$.pipe(ofType(AuthValidationError), take(1)).subscribe(({validationError}) => {
      this.validationError.set(validationError);
    });

    this.actions$.pipe(ofType(LoginFailure), take(1)).subscribe(({ error }) => {
      this.validationError.set([error]);
    });

    this.actions$.pipe(ofType(LoginSuccess), take(1)).subscribe(() => {
      this.router.navigate(['/']);
    });
  }
}
